import Joi from "joi-browser";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import userIcon from "include/images/user.png";

//  Components
import Form from "common/form/form";
import MultiSelectSearchAsync from "common/form/multiSelectSearchAsync";
import NextButton from "common/form/submitButton";
import {
  addBattleGame,
  addUserGears,
  getTelegram,
  loadGearsCsv,
  loadUserGears,
  updateBattleGame,
} from "store/telegram";
import { toast } from "react-toastify";
import AlertSuccess from "common/alert/alertSuccess";
import AlertError from "common/alert/alertError";

class AddGearsFlyer extends Form {
  initialState = {
    loading: false,
    loadingMain: false,
    loadingGears: false,
    data: {
      gears: [],
    },
    errors: {},
  };
  state = { ...structuredClone(this.initialState) };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      if (!this.props.showModal) this.clearData();
      else {
        if (this.props.user) {
          this.setState({ loadingMain: true });
          this.props.loadUserGears(this.props.user?._id, (res) => {
            this.setState({ loadingMain: false });

            if (res?.status === 200) {
              this.setState({
                data: {
                  gears: res?.data?.data?.map((gear) => ({
                    name: `${gear?.name} - ${gear?.type} - ${gear?.subType} - ${gear?.gearId}`,
                    value: gear?._id,
                    data: gear,
                  })),
                },
              });
            } else {
              toast(<AlertError message={res.data && res.data.message} />, {
                containerId: 1,
              });
            }
          });
        }
      }
    }
  };
  doSubmit = (e) => {
    const data = { ...this.state.data };

    this.setState({ loading: true });
    const payLoad = {
      gears: data.gears.map((gear) => ({ gearId: gear?.value, gearWonType: gear?.gearWonType ?? 6 })),
    };
    this.props.addUserGears(this.props.user?._id, payLoad, (res) => {
      this.setState({ loading: false });
      if (res?.status === 200) {
        toast(<AlertSuccess message="Information Saved" />, {
          containerId: 1,
        });
        this.props.toggleModal();
      } else {
        toast(<AlertError message={res.data && res.data.message} />, {
          containerId: 1,
        });
      }
    });
  };
  schema = {
    gears: Joi.array()
      .min(0)
      .items(
        Joi.object().keys({
          data: Joi.object().allow(null),
          name: Joi.string().allow(""),
          value: Joi.string().required(),
        }),
      ),
  };
  clearData = () => {
    this.setState({ ...structuredClone(this.initialState) });
  };

  onChange = (e) => {
    const data = this.state.data;
    const errors = this.state.errors;
    data[e.name] = e.currentTarget;
    delete errors[e.name];
    this.setState({ data, errors });
  };
  loadOptions = (inputValue, callback) => {
    this.setState({ loadingGears: true });
    this.props.loadGearsCsv({ name: inputValue, sort: "name", order: "asc" }, (res) => {
      if (res?.status === 200) {
        callback(
          res?.data?.data?.map((s, i) => ({
            name: `${s?.name} - ${s?.type} - ${s?.subType} - ${s?.gearId}`,
            value: s?._id,
            data: s,
          })),
        );
      }
      this.setState({ loadingGears: false });
    });
  };
  render() {
    const { user } = this.props;
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end custom-offcanvas-pannel "}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header className="offCanvas-header-2">
          <div>
            <h5>User Gears</h5>
            <div className="td-img-group d-flex align-items-start m-top-2">
              <div className="td-img round-img m-right-2 pointer">
                <img src={user?.image?.small ? process.env.REACT_APP_CDN + user.image.small : userIcon} alt="" />
              </div>
              {user?.firstName} {user?.lastName}
              <br />
              {user?.userName}
            </div>
          </div>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-check-outer">
            {!this.state.loadingMain && (
              <div className="new-form-group">
                <div className="row">
                  <div className="new-form-group">
                    <label className="form-label">Gears</label>
                    <MultiSelectSearchAsync
                      name="gears"
                      label="Select Gears"
                      value={this.state?.data?.gears}
                      error={this.state?.errors?.gears}
                      onChange={this.onChange}
                      isLoading={this.state.loadingGears}
                      loadOptions={this.loadOptions}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loading}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
const mapDispatchToProps = (dispatch) => ({
  loadGearsCsv: (params, callback) => dispatch(loadGearsCsv(params, callback)),
  loadUserGears: (id, callback) => dispatch(loadUserGears(id, callback)),
  addUserGears: (id, data, callback) => dispatch(addUserGears(id, data, callback)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddGearsFlyer));
